import React from 'react';
import Image from 'next/image';
import OverviewStyles from './Overview.styled';
import propTypes from 'prop-types';
import ScrollLink from '../../Shared/ScrollLink/ScrollLink';

const Overview = ({
  overviewHeader,
  overview,
  quote,
  overviewLinkText,
  overviewLink,
}) => {
  const imageAlt = quote?.featuredImage?.description;
  const isAnchorLink = overviewLink?.startsWith('#');

  return (
    <OverviewStyles quote={quote}>
      <div className="overview-container">
        {overviewHeader && <h1>{overviewHeader}</h1>}
        <p>{overview}</p>
        {overviewLink ? (
          <ScrollLink
            className="cta-button gtm-ugc-story-cta1"
            to={overviewLink}
            href={overviewLink}
            useScroll={isAnchorLink}
            target={isAnchorLink ? '_self' : '_blank'}
            tabIndex="0"
          >
            {overviewLinkText}
          </ScrollLink>
        ) : null}
      </div>
      {quote && (
        <div className="quote-container">
          <picture>
            <Image
              alt={imageAlt}
              title={imageAlt}
              src={`${quote.featuredImage?.file?.url}?h=523`}
              width="380"
              height="506"
            />
          </picture>
          <div className="text-container">
            <p>{quote.sectionLabel ? quote.sectionLabel : ''}</p>
            <h4>{quote.sectionContent ? quote.sectionContent : ''}</h4>
          </div>
        </div>
      )}
    </OverviewStyles>
  );
};

Overview.propTypes = {
  overviewHeader: propTypes.string.isRequired,
  overview: propTypes.string.isRequired,
  quote: propTypes.object,
  overviewLinkText: propTypes.string,
  overviewLink: propTypes.string,
};

export default Overview;
